export default "__VITE_ASSET__37bde31f__"